import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'stone' | 'warm';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    stone: 'bg-stone-50',
    warm: 'bg-orange-50/50'
  };
  return <section id={id} className={`py-8 md:py-12 ${backgrounds[background]} ${className}`} data-id="element-286">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-287">{children}</div>
    </section>;
}